import {
  FETCH_PRODUCT_PACKAGING,
  RESET_PRODUCT_PACKAGING,
} from "../../constants/action.constants";

const initialState = {
  data: {},
};

const productPackagingViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_PACKAGING:
      return { data: action.payload };
    case RESET_PRODUCT_PACKAGING:
      return initialState;
    default:
      return state;
  }
};

export default productPackagingViewReducer;
